import { get } from "../../utils/requests";
import Button from "../../buttons/Button";
import Dialog from "../../dialogs/Dialog";
import Grid from "../../dataGrid/DataGrid";
import flags from "../../dataGrid/flags";
import { filterBy } from "@progress/kendo-data-query";
import "./IUzComponents.scss"
import LoadingPanel from "../../LoadingPanel";
import { getSrvConfig } from "../../utils/storage";
import { buildUrl } from "../../utils/helper";

let allUsers;

/**
 * Získanie používateľov z domény
 * @param {*} value 
 * @param {*} onChange 
 * @param {*} obj 
 * @returns 
 */
export const GetDomainUz = (value, onChange, obj) => {
  const config = getSrvConfig();
  const domain = config?.loginConfig?.ldap?.domain || null;
  const enable = config?.loginConfig?.ldap?.disabled === false ? true : false;

  const handleClick = async () => {
    await onChange("LdapUsersLoading", true);
    try {
      const res = await get(`/api/meta/ldap-users?domain=${domain}`);
      if (res?.Data) {
        allUsers = res.Data
        await onChange("LdapUsers", allUsers);
      }
      else {
        obj?.showMsg("Nenašli sa používatelia v doméne", "error")
      }
    } catch (error) {
      obj?.showMsg("Nepodarilo sa získať používateľov", "error")
    }
    await onChange("LdapUsersLoading", false);
  }

  const close = () => {
    allUsers = null;
    onChange("LdapUsers", null);
  }

  const onClick = (item) => {
    if (!item) return
    onChange("LdapUser", item.Data);
  }

  const handleConfirm = async () => {
    if (!obj.data.LdapUser) return;
    await onChange("NUz", obj.data.LdapUser.NUz);
    await onChange("NDomena", obj.data.LdapUser.NDomena);
    await onChange("Email", obj.data.LdapUser.Email);
    await onChange("TtUz", obj.data.LdapUser.TtUz);
    await onChange("SkrUz", obj.data.LdapUser.SkrUz);

    close()
  }

  const handleChange = async (filter) => {
    filter.logic = "and";
    onChange("LdapUsers", filterBy(allUsers, filter));
  }

  const users = obj.data.LdapUsers || allUsers;
  const schemaItem = obj.schema.find(x => x.field === obj.name);

  return (
    <>
      <div className="get-domain-uz">
        {obj.buildField(schemaItem)}
        {enable &&
          <Button
            imageUrl={buildUrl('assets/icons/toolbar/add-person.svg')}
            onClick={handleClick}
            disabled={!domain}
            title={"Výber používateľa z domény"}
          />
        }
      </div>

      <Dialog
        isOpen={!!users}
        title={"Výber používateľa z domény"}
        onClose={close}
        onConfirm={handleConfirm}
        confirmDisabled={!obj.data.LdapUser}
        disableConfirmOnEnter={true}
      >
        <Grid
          data={users || []}
          total={users?.length}
          primaryField="NUz"
          schema={[
            { field: "NUz", title: "Názov", width: 250, sortable: false, filterable: true, hiddenLocked: true },
            { field: "Email", title: "E-mail", width: 250, sortable: false, filterable: true, hiddenLocked: true },
            { field: "NDomena", title: "Doména", width: 100, sortable: false, filterable: true, hiddenLocked: true },
          ]}
          page={{ skip: 0, take: 500 }}
          onChange={handleChange}
          onGetList={() => { }}
          onGet={onClick}
          hidden={flags.TOOLBAR | flags.PAGING | flags.DETAIL | flags.COLUMN_MENU}
          selected={obj.data.LdapUser ? [obj.data.LdapUser] : []}
          onChangeSchema={() => { }}
          filter={{ filters: [] }}
          fixedFilter={{ filters: [] }}
          allColumns={true}
          isLoading={false}
          sort={[]}
        />
      </Dialog>

      <LoadingPanel isLoading={!!obj?.data?.LdapUsersLoading} />
    </>

  );
}